export const handleOptions = (payload = [], storeData = [], id) => {
  return payload.map((item) => {
    const storeItem =
      storeData.find((storeItem) => storeItem[id] === item[id]) || {}

    return {
      ...item,
      children: (item.children || []).map((child) => {
        const storeChildData =
          (storeItem.children || []).find(
            (storeItem) => storeItem[id] === child[id],
          ) || {}

        return {
          ...child,
          isChecked: storeChildData.isChecked,
        }
      }),
      isChecked: storeItem.isChecked,
    }
  })
}

export const getDataTable = (payload, ids) => {
  if (!payload) return {}

  const tableData = {}
  ids.forEach((id) => {
    tableData[id] = { ...payload.find((item) => `${item.newsId}` === id) }
    tableData[id + '-shortContent'] = {
      shortContent: payload.find((item) => `${item.newsId}` === id)
        .shortContent,
      sourceUrl: payload.find((item) => `${item.newsId}` === id).sourceUrl,
    }
  })
  return tableData
}

export const getCheckedIdsOfEvents = (options) => {
  const checkedIds = []

  options.forEach((option) => {
    if (option.isChecked && option.isChecked !== -1) {
      checkedIds.push(option.newsCategoryId)
    }

    option.children.forEach((child) => {
      if (child.isChecked && child.isChecked !== -1) {
        checkedIds.push(child.newsCategoryId)
      }
    })
  })

  return checkedIds
}

export const getParentChecked = (children) => {
  const lengthChecked = children.filter((child) => child.isChecked).length

  if (children.length && lengthChecked === children.length) {
    return true
  }

  return lengthChecked ? -1 : false
}
